import styled from "styled-components";
import fipayFonts from "../../../../theme/index";
import { colors } from "../../../../theme/color";

export const CarouselContainer = styled.div`
  width: 60%;
  height: 465px;
  display: flex;
  /* flex-direction: column; */
  /* padding-right: 1605px; */
  align-items: center;
  /* border: 2px solid red; */
  overflow: scroll;
  padding-left: 20px;
  box-sizing: border-box;
  overflow: hidden;
  /* margin-right: 60px; */

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 420px;
    margin-right: 0px;
    /* top: 60px
left: 70px
gap: 21px */

    display: flex;
    align-items: flex-start;
    gap: 21px;
  }

  @media screen and (max-width: 375px) {
    width: 351px;
    height: 411px;
    box-sizing: border-box;
    /* top: 373px
left: 24px */
  }
  @media screen and (max-width: 320px) {
    width: 100%;
    height: 411px;
    box-sizing: border-box;
    /* top: 373px
left: 24px */
  }
`;
